import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { MLoader } from '../components/molecules';
import {
	OReferenceBasicInfo,
	OFeaturedImageUpload,
	ODestructiveButtons,
} from '../components/organisme';

import { CMS_CONFIG } from '../config/cms.config';
import { setCmsHead } from '../redux/head/headActions';
import store from '../redux/store/store';
import { updateForm, addReference, updateReference, initForm } from '../redux/cms/cmsActions';
import withAuthGuard from '../helpers/withAuthGuard';

import { routes } from '../constants';

const mapStateToProps = state => ({
	name: get(state, 'cms.form.name.value', ''),
	url: get(state, 'cms.form.url.value', ''),
	featuredImage: get(state, 'cms.form.featuredImage.value', ''),
	isValid: state.cms.isFormValid,
	isUploading: state.cms.isUploading,
	uploadingFailed: state.cms.uploadingFailed,
});

class CreateReferencePage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isEditMode: false,
		};

		this.bindHandles();
	}
	componentDidMount() {
		const editMode = this.checkForEditMode();

		this.props.setCmsHead({ ...CMS_CONFIG.REFERENCE.header.create });
		this.initForm({ editMode });
	}

	checkForEditMode() {
		const isEditMode = 'slug' in this.props.match.params;

		this.setState({ isEditMode });

		return isEditMode;
	}

	initForm({ editMode = false }) {
		let values = {};

		if (editMode) {
			values = store.getState().content.references.find(item => item.uuid === this.props.match.params.slug);
			if (!values) {
				this.props.history.push(`${routes.CMS.DEFAULT}${routes.CMS.REFERENCE}`);
				return;
			}
			if (values) {
				values.featuredImage = get(values, 'image', '');
			}
		}

		this.props.initForm({
			fields: CMS_CONFIG.CREATE.reference,
			values,
		});
	}

	bindHandles() {
		this.handleFieldChange = this.handleFieldChange.bind(this);
		this.handleSave = this.handleSave.bind(this);
	}

	handleFieldChange({ field, value, error }) {
		this.props.updateForm({ key: field, value, valid: !error });
	}

	handleSave() {
		if (!this.props.isValid) {
			return;
		}
		if (this.state.isEditMode) {
			this.props.updateReference(this.props.history);
		} else {
			this.props.addReference(this.props.history);
		}
	}


	render() {
		let content;

		if (this.props.isUploading) {
			content = <MLoader className="article--loader article--loader-create" />;
		}

		return (
			<div className="layout-cms--wrapper">
				<div className="layout-cms--content-body--create">
					<OReferenceBasicInfo
						name={this.props.name}
						url={this.props.url}
						onNameChange={(value, error) => this.handleFieldChange({ field: 'name', value, error })}
						onUrlChange={(value, error) => this.handleFieldChange({ field: 'url', value, error })}
						onDescriptionChange={(value, error) => this.handleFieldChange({ field: 'description', value, error })}
					/>
					<OFeaturedImageUpload
						id="referenceImage"
						title="feature image"
						imageURL={this.props.featuredImage.url}
						className="o-cms-file-upload--reference"
						onUpload={(value, error) => this.handleFieldChange({ field: 'featuredImage', value, error })}
					/>
				</div>
				<div className="section-cms--destructive-buttons">
					<ODestructiveButtons
						saveEnabled={this.props.isValid}
						onSave={this.handleSave}
					/>
				</div>
				{content}
			</div>
		);
	}
}

CreateReferencePage.propTypes = {
	setCmsHead: PropTypes.func.isRequired,
	updateForm: PropTypes.func.isRequired,
	addReference: PropTypes.func.isRequired,
	updateReference: PropTypes.func.isRequired,
	initForm: PropTypes.func.isRequired,
};

export default withAuthGuard(withRouter(connect(mapStateToProps, {
	setCmsHead,
	updateForm,
	addReference,
	updateReference,
	initForm,
})(CreateReferencePage)));



// WEBPACK FOOTER //
// ./src/CMS/create-reference.js